import type { GridColDef } from '@mui/x-data-grid-pro';
import type { Sport, SportList } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { createEditColumn, createIsActiveColumn, createCashOutColumn } from '../../helpers/columns';
import { defaultColumnsSports } from '../../helpers/table';
import useMutateData from '../../hooks/useMutateData';
import { usePagination } from '../../hooks/usePagination';
import useSort from '../../hooks/useSort';
import { createColumn } from '../../utils';
import IconRenderer from '../atoms/IconRenderer';
import TableIconContainer from '../atoms/TableIconContainer';
import TableTemplate from '../templates/TableTemplate';
import usePermissions from '../../hooks/usePermissions';

const SportsPage = () => {
  const {
    data: sportsData,
    updateQueryParams,
    isFetching,
    isLoading,
    changeQuery,
  } = usePagination<SportList>('sports');
  const { deleteData, updateData } = useMutateData('sports', [QUERY_KEYS.sports]);
  const { handleSort } = useSort(changeQuery);
  const { hasPermission } = usePermissions();
  const showCashout = hasPermission('manageCashOut');

  const handleSearch = (value: string | null) => {
    changeQuery({ search: value });
  };

  const columns: GridColDef[] = [
    createColumn('id', 'ID', {
      sortable: false,
    }),
    createColumn('icon', 'Icon', {
      sortable: false,
      renderCell: (params) => {
        return (
          <TableIconContainer>
            <IconRenderer name={params.value} />
          </TableIconContainer>
        );
      },
    }),
    createColumn('name', 'Sport Name'),
    createColumn('shortName', 'Sport Short Name'),
    createColumn('position', 'Position'),
    createIsActiveColumn<Sport>({
      updateData,
    }),
    createEditColumn<Sport>({
      deleteData,
      columnName: 'Actions',
    }),
  ];
  showCashout && columns.splice(-1, 0, createCashOutColumn<Sport>({ updateData, modalEntity: 'sport' }));

  return (
    <TableTemplate
      rows={sportsData?.items || []}
      columns={columns}
      loading={isFetching || isLoading}
      rowCount={sportsData?.count ?? 0}
      createItemBtnLabel='Add new sport'
      defaultVisibleColumns={defaultColumnsSports}
      handlePaginationModelChange={updateQueryParams}
      handleSearch={handleSearch}
      handleSort={handleSort}
      changeQuery={changeQuery}
      formType='sports'
      showExport
    />
  );
};

export default SportsPage;
